module.exports = __webpack_public_path__ + "static/media/blog3.bf68c01d.jpg";